import * as React from "react";
import LocationList from "../../presentations/LocationList";

const LocationListContainer = (props: any) => {

  const { onEdit } = props;

  const handleOnEdit = (rowData: any) => {
    onEdit(rowData);
  }

  return (
    <div>
      <LocationList onEdit={handleOnEdit}></LocationList>
    </div>
  );
};

export default LocationListContainer;
